module.exports = __webpack_public_path__ + "img/conveniencias-05.9b90067d.png";